export const FaqAccordionCss = {
  accordionItem: {
    border: "none",
    marginBottom: "10px"
  }
};
